export enum UtmChanelEnum {
  SHOP_BACK = "40",
  WEB = "47",
  KBANK = "45",
  KTB = "44",
  NEXT = "46",
  PROMOTION_1_KTB = "50",
  PROMOTION_2_KTB = "51",
  GOTHER_APP_IOS = "48",
  GOTHER_APP_ANDROID = "49",
  RADAR_POINT_UAT = "1013",
  RADAR_POINT_PROD = "1046",

  GOOGLE = "53",
  HONEY_COMB = "54",
  SKY_SCANNER = "55",
}
// NOTE - check utmId
const banks = [UtmChanelEnum.KBANK, UtmChanelEnum.KTB, UtmChanelEnum.NEXT];
export const isBank = (utmId: string) => {
  return banks.includes(`${utmId}` as UtmChanelEnum);
};
export const affiliatesUtmGroup = [
  UtmChanelEnum.HONEY_COMB,
  UtmChanelEnum.SKY_SCANNER,
  UtmChanelEnum.SHOP_BACK,
];
export const partnerAffiliatesUtmGroup = [UtmChanelEnum.HONEY_COMB];
export const GoogleUtmGroup = [UtmChanelEnum.GOOGLE];
